// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    MapPinSearch,
    MapPinX,
    MapPinXInside,
    MapPinned,
    MapPlus,
    Mars,
    MarsStroke,
    Martini,
    Maximize,
    Maximize2,
    Medal,
    Megaphone,
    MegaphoneOff,
    MemoryStick,
    Menu,
    Merge,
    MessageCircle,
    MessageCircleCheck,
    MessageCircleCode,
    MessageCircleDashed,
    MessageCircleDashedCheck,
    MessageCircleHeart,
    MessageCircleMore,
    MessageCircleOff,
    MessageCirclePlus,
    MessageCircleQuestionMark,
    MessageCircleReply,
    MessageCircleWarning,
    MessageCircleX,
    MessageSquare,
    MessageSquareCheck,
    MessageSquareCode,
    MessageSquareDashed,
    MessageSquareDiff,
    MessageSquareDot,
    MessageSquareHeart,
    MessageSquareLock,
    MessageSquareMore,
    MessageSquareOff,
    MessageSquarePlus,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "map-pin-search" through "message-square-plus", inclusive. */
const shard: Record<string, LucideIcon> = {
    "map-pin-search": MapPinSearch,
    "map-pin-x": MapPinX,
    "map-pin-x-inside": MapPinXInside,
    "map-pinned": MapPinned,
    "map-plus": MapPlus,
    mars: Mars,
    "mars-stroke": MarsStroke,
    martini: Martini,
    maximize: Maximize,
    "maximize-2": Maximize2,
    medal: Medal,
    megaphone: Megaphone,
    "megaphone-off": MegaphoneOff,
    "memory-stick": MemoryStick,
    menu: Menu,
    merge: Merge,
    "message-circle": MessageCircle,
    "message-circle-check": MessageCircleCheck,
    "message-circle-code": MessageCircleCode,
    "message-circle-dashed": MessageCircleDashed,
    "message-circle-dashed-check": MessageCircleDashedCheck,
    "message-circle-heart": MessageCircleHeart,
    "message-circle-more": MessageCircleMore,
    "message-circle-off": MessageCircleOff,
    "message-circle-plus": MessageCirclePlus,
    "message-circle-question-mark": MessageCircleQuestionMark,
    "message-circle-reply": MessageCircleReply,
    "message-circle-warning": MessageCircleWarning,
    "message-circle-x": MessageCircleX,
    "message-square": MessageSquare,
    "message-square-check": MessageSquareCheck,
    "message-square-code": MessageSquareCode,
    "message-square-dashed": MessageSquareDashed,
    "message-square-diff": MessageSquareDiff,
    "message-square-dot": MessageSquareDot,
    "message-square-heart": MessageSquareHeart,
    "message-square-lock": MessageSquareLock,
    "message-square-more": MessageSquareMore,
    "message-square-off": MessageSquareOff,
    "message-square-plus": MessageSquarePlus,
};

export default shard;
